import { LineOfBusiness } from 'src/app/shared/models/enums/line-of-business';

export enum CategoryLineOfBusiness {
    All = 0,
    Travel = 1,
    Locums = 2,
    AccessControl = 3
}

export function nameOfCategoryLine(value: CategoryLineOfBusiness): string {
    switch (value) {
        case CategoryLineOfBusiness.Travel:
            return 'Travel';
        case CategoryLineOfBusiness.Locums:
            return 'Locums';
        case CategoryLineOfBusiness.AccessControl:
            return 'Access Control';
        case CategoryLineOfBusiness.All:
            return 'All';
    }
}

export function MapCategoryLineOfBusinessToLineOfBusiness(clob: CategoryLineOfBusiness): LineOfBusiness {
    switch (clob) {
        case CategoryLineOfBusiness.AccessControl:
            return LineOfBusiness.AccessControl;
        case CategoryLineOfBusiness.Locums:
            return LineOfBusiness.Locums;
        default:
            return LineOfBusiness.Travel;
    }
}

export function MapLineOfBusinessToCategory(lineOfBusiness: LineOfBusiness): CategoryLineOfBusiness {
    switch (lineOfBusiness) {
        case LineOfBusiness.AccessControl:
            return CategoryLineOfBusiness.AccessControl;
        case LineOfBusiness.Locums:
            return CategoryLineOfBusiness.Locums;
        default:
            return CategoryLineOfBusiness.Travel;
    }
}
